import React, { useState, useRef, useCallback } from "react";
import { GoogleMap, Marker, Autocomplete } from "@react-google-maps/api";
import {
  Box,
  Fab,
  Stack,
  useMediaQuery,
  useTheme,
  TextField,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DoneIcon from "@mui/icons-material/Done";
import MyLocationIcon from "@mui/icons-material/MyLocation";
import target from "./target.png";

const containerStyle = { width: "100%", height: "100%" };
const center = { lat: 16.4324, lng: 102.8352 };

function MapSinglePin({ data }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const mapRef = useRef(null);
  const autocompleteRef = useRef(null);
  const [currentCenter, setCurrentCenter] = useState(center);
  const [pin, setPin] = useState(null);
  const [searchInput, setSearchInput] = useState("");
  const hasSetCenterListener = useRef(false);

  const onLoad = useCallback((map) => {
    mapRef.current = map;

    if (!hasSetCenterListener.current) {
      hasSetCenterListener.current = true;

      map.addListener("idle", () => {
        const center = map.getCenter();
        const lat = center.lat();
        const lng = center.lng();
        setCurrentCenter({ lat, lng });
      });
    }
  }, []);
  const onPlaceChanged = () => {
    if (autocompleteRef.current !== null) {
      const place = autocompleteRef.current.getPlace();
      if (place.geometry) {
        const loc = {
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng(),
        };
        setCurrentCenter(loc);
        mapRef.current?.panTo(loc);
        mapRef.current?.setZoom(18);
      }
    }
  };

  const goToMyLocation = () => {
    if (!navigator.geolocation) return console.error("No geolocation support");
    navigator.geolocation.getCurrentPosition(
      ({ coords }) => {
        const loc = { lat: coords.latitude, lng: coords.longitude };
        setCurrentCenter(loc);
        mapRef.current?.panTo(loc);
        mapRef.current?.setZoom(18);
      },
      (error) => console.error("Location error:", error.message),
      { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
    );
  };

  const handleAddPin = () => {
    if (mapRef.current) {
      const center = mapRef.current.getCenter();
      const newPin = { lat: center.lat(), lng: center.lng() };
      setPin(newPin);
      console.log("Pin set at:", newPin);
    }
  };

  const handleConfirm = () => {
    if (pin) {
      console.log("Pin location :", pin);
      data({ confirm: true, point: pin });
    } else {
      console.warn("ยังไม่ได้กด Add เพื่อวาง pin");
    }
  };

  return (
    <Box position="relative" width="100%" height="100%">
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={currentCenter}
        zoom={18}
        onLoad={onLoad}
        options={{ gestureHandling: "greedy" }}
      >
        {pin && <Marker position={pin} />}
      </GoogleMap>


      <Box
        position="absolute"
        top={isMobile?60:16}
        left="50%"
        sx={{
          transform: "translateX(-50%)",
          zIndex: 2,
          width: isMobile ? "90%" : 400,
        }}
      >
        <Autocomplete
          onLoad={(ref) => (autocompleteRef.current = ref)}
          onPlaceChanged={onPlaceChanged}
        >
          <TextField
            fullWidth
            variant="outlined"
            placeholder="ค้นหาสถานที่..."
            value={searchInput}
            onChange={(e) => setSearchInput(e.target.value)}
            sx={{ backgroundColor: "white", borderRadius: 1 }}
          />
        </Autocomplete>
      </Box>

      {/* Center Target Image */}
      <Box
        position="absolute"
        top="50%"
        left="50%"
        sx={{
          transform: "translate(-50%, -50%)",
          zIndex: 2,
          pointerEvents: "none",
        }}
      >
        <img src={target} alt="target" width={32} height={32} />
      </Box>

      {/* Buttons */}
      <Box
        position="absolute"
        bottom={16}
        left="50%"
        sx={{ transform: "translateX(-50%)" }}
        zIndex={2}
      >
        <Stack direction="row" spacing={2}>
          <Fab color="secondary" size="medium" onClick={goToMyLocation}>
            <MyLocationIcon />
          </Fab>
          <Fab color="primary" size="medium" onClick={handleAddPin}>
            <AddIcon />
          </Fab>
          <Fab
            color="success"
            size="medium"
            onClick={handleConfirm}
            disabled={!pin}
          >
            <DoneIcon />
          </Fab>
        </Stack>
      </Box>
    </Box>
  );
}

export default MapSinglePin;
